import { render, staticRenderFns } from "./Forgot_password.vue?vue&type=template&id=639b3911&"
import script from "./Forgot_password.vue?vue&type=script&lang=js&"
export * from "./Forgot_password.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports